import React, { ReactNode } from 'react';
import { isArray } from 'lodash';
import { childrenIdMatch } from '../utils';

export const excludeChildrenByType = (children: ReactNode, id: string | string[]) =>
    React.Children.toArray(children).filter((child) => {
        if (isArray(id)) {
            return !id.some((singleId) => childrenIdMatch(child, singleId));
        }

        return !childrenIdMatch(child, id);
    });
